import { useDispatch } from "react-redux"
import Box from "../../../../components/Box"
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect"
import { GetCompanyByIdResponse } from "../../../../models/response/company/GetCompanyByIdResponse"
import { storeActivityIndicator, storeFastFirm } from "../../../../redux/reducers/authSlice"
import { CompanyService } from "../../../../services/CompanyService"
import { ConstantService } from "../../../../services/ConstantService"
import { KTCard } from "../../../../_metronic/helpers/components/KTCard"
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody"
import toast from "react-hot-toast";
import { CountryService } from "../../../../services/CountryService"

interface Props {
    firmInformationRef: any
    selectedSenderFirm: CustomSingleSelectModel | undefined
    setSelectedSenderFirm: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedReceiverFirm: CustomSingleSelectModel | undefined
    setSelectedReceiverFirm: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDutyFirm: CustomSingleSelectModel | undefined
    setSelectedDutyFirm: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedExitCountry: CustomSingleSelectModel | undefined
    setSelectedExitCountry: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedRepresentative: CustomSingleSelectModel | undefined
    setSelectedRepresentative: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    isDisabledFromLock: boolean
}

const FirmInformation = ({
    firmInformationRef,
    selectedReceiverFirm,
    selectedSenderFirm,
    setSelectedReceiverFirm,
    setSelectedSenderFirm,
    selectedDutyFirm,
    setSelectedDutyFirm,
    selectedExitCountry,
    setSelectedExitCountry,
    selectedRepresentative,
    setSelectedRepresentative,
    isDisabledFromLock
}: Props) => {
    const dispatch = useDispatch();

    const onSelectedSenderFirmChange = async (_selectedValue: CustomSingleSelectModel | undefined) => {
        try {
            if (_selectedValue) {
                dispatch(storeActivityIndicator(true))

                var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(_selectedValue.value);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    dispatch(storeActivityIndicator(false))
                    return;
                }

                setSelectedSenderFirm(_selectedValue);

                if (response.data.companyAddresses.length > 0) {
                    var address = response.data.companyAddresses.find(x => x.isDefault);

                    if (!address)
                        address = response.data.companyAddresses[0];

                    if (address.countryId && address.countryName) {
                        setSelectedExitCountry({ label: address.countryName, value: address.countryId })
                    }
                    else {
                        setSelectedExitCountry(undefined);
                    }
                }
                else {
                    setSelectedExitCountry(undefined);
                }
            }
            else {
                setSelectedSenderFirm(undefined);
                setSelectedExitCountry(undefined);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <div className='containerPart' ref={firmInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Firma Bilgileri</h4>

                    <Box gap="20px" flexDirection="row">
                        <Box flex={1 / 3}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Alıcı Firma</label>
                                <CustomSingleSelect
                                    selectedValue={selectedReceiverFirm}
                                    onChange={setSelectedReceiverFirm}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedReceiverFirm?.value,
                                                isReceiverFirm: true,
                                                isCustomer: true,
                                                onSubmit: async (response) => {
                                                    setSelectedReceiverFirm({ label: response.name, value: response.companyId })
                                                },
                                            }))
                                        }
                                    }}
                                    onMenuOpen={[
                                        () => CompanyService.getCompanyList({ isReceiverFirm: true }),
                                        () => CompanyService.getCompanyList({ isCustomer: true }),
                                    ]}
                                    labelName='name'
                                    valueName='companyId'
                                    disabled={isDisabledFromLock}
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Gönderici Firma</label>
                                <CustomSingleSelect
                                    selectedValue={selectedSenderFirm}
                                    onChange={onSelectedSenderFirmChange}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedSenderFirm?.value,
                                                isSenderFirm: true,
                                                onSubmit: async (response) => {
                                                    onSelectedSenderFirmChange({ label: response.name, value: response.companyId })
                                                },
                                            }))
                                        }
                                    }}
                                    onMenuOpen={[
                                        () => CompanyService.getCompanyList({ isSenderFirm: true }),
                                        () => CompanyService.getCompanyList({ isCustomer: true }),
                                    ]}
                                    labelName='name'
                                    valueName='companyId'
                                    disabled={isDisabledFromLock}
                                />
                            </div>
                        </Box>

                        <Box flex={1 / 3}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Gümrük Firması</label>

                                <CustomSingleSelect
                                    selectedValue={selectedDutyFirm}
                                    onChange={setSelectedDutyFirm}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedDutyFirm?.value,
                                                isDutyFirm: true,
                                                onSubmit: async (response) => {
                                                    setSelectedDutyFirm({ label: response.name, value: response.companyId })
                                                },
                                            }))
                                        }
                                    }}
                                    onMenuOpen={() => CompanyService.getCompanyList({ isDutyFirm: true })}
                                    labelName='name'
                                    valueName='companyId'
                                    disabled={isDisabledFromLock}
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Çıkış Ülkesi</label>

                                <CustomSingleSelect
                                    selectedValue={selectedExitCountry}
                                    onChange={setSelectedExitCountry}
                                    onMenuOpen={() => CountryService.getCountryList()}
                                    labelName='name'
                                    valueName='countryId'
                                    disabled={isDisabledFromLock}
                                />
                            </div>
                        </Box>

                        <Box flex={1 / 3}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Mümessil Firma</label>

                                <CustomSingleSelect
                                    selectedValue={selectedRepresentative}
                                    onChange={setSelectedRepresentative}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedRepresentative?.value,
                                                isRepresentative: true,
                                                onSubmit: async (response) => {
                                                    setSelectedRepresentative({ label: response.name, value: response.companyId })
                                                },
                                            }))
                                        }
                                    }}
                                    onMenuOpen={[
                                        () => CompanyService.getCompanyList({ isRepresentative: true }),
                                        () => CompanyService.getCompanyList({ isCustomer: true }),
                                    ]}
                                    labelName='name'
                                    valueName='companyId'
                                    disabled={isDisabledFromLock}
                                />
                            </div>
                        </Box>
                    </Box>
                </KTCardBody>
            </KTCard>
        </div >
    )
}

export default FirmInformation;